// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/icons.css
// module id = 1327
// module chunks = 37